import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["background", "borderRadius", "border", "children"],
  _excluded2 = ["background", "children", "paddingBlock", "paddingInline"],
  _excluded3 = ["background", "borderBlockStart", "children", "paddingBlock", "paddingInline"],
  _excluded4 = ["size", "variant"],
  _excluded5 = ["children", "paddingBlock", "paddingInline"];
import { LayoutDividerVertical } from '../Layout/LayoutDividerVertical';
import { Collapsible } from './Collapsible';
import { jsx as _jsx } from "react/jsx-runtime";
export const CollapsibleCard = _ref => {
  let {
      background = 'background-color-light',
      borderRadius = 'border-radius',
      border = 'border',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Collapsible, Object.assign({}, rest, {
    background: background,
    border: border,
    borderRadius: borderRadius,
    children: /*#__PURE__*/_jsx(LayoutDividerVertical, {
      gap: "0",
      children: children
    })
  }));
};
const Header = _ref2 => {
  let {
      background = 'background-color-light',
      children,
      paddingBlock = 'space-sm',
      paddingInline = 'space-md'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Collapsible.Header, Object.assign({}, rest, {
    background: background,
    paddingBlock: paddingBlock,
    paddingInline: paddingInline,
    children: children
  }));
};
Header.displayName = 'CollapsibleCard.Header';
CollapsibleCard.Header = Header;
const Footer = _ref3 => {
  let {
      background = 'background-color-light',
      borderBlockStart = 'border',
      children,
      paddingBlock = 'space-sm',
      paddingInline = 'space-md'
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(Collapsible.Footer, Object.assign({}, rest, {
    background: background,
    borderBlockStart: borderBlockStart,
    paddingBlock: paddingBlock,
    paddingInline: paddingInline,
    children: children
  }));
};
Footer.displayName = 'CollapsibleCard.Footer';
CollapsibleCard.Footer = Footer;
const Toggle = _ref4 => {
  let {
      size = 'xxxs',
      variant = 'interactive'
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /*#__PURE__*/_jsx(Collapsible.Toggle, Object.assign({
    size: size,
    variant: variant
  }, rest));
};
Toggle.displayName = 'CollapsibleCard.Toggle';
CollapsibleCard.Toggle = Toggle;
const Content = _ref5 => {
  let {
      children,
      paddingBlock = 'space',
      paddingInline = 'space-md'
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(Collapsible.Content, Object.assign({}, rest, {
    paddingBlock: paddingBlock,
    paddingInline: paddingInline,
    children: children
  }));
};
Content.displayName = 'CollapsibleCard.Content';
CollapsibleCard.Content = Content;